import PageSerializer from '@linc-technologies/linced-common/serializers/posts/page';

export default class Page extends PageSerializer {
  normalize(model, hash, prop) {
    hash.assessment_ids = hash.assessmentIds;
    hash.page_template_id = hash.pageTemplateId;
    return super.normalize(model, hash, prop);
  }
}
